import axios from 'axios'
import {ProfileType} from '../core/_models'
import {serialize} from '../../../core/_util'

export const API_URL = process.env.REACT_APP_BASE_API_URL
const GET_PROFILE_DATA = `${API_URL}/user`
const UPDATE_PROFILE_DATA = `${API_URL}/user`
const CREATE_EMAIL_PREFERENCES = `${API_URL}/email-preferences`
const UPDATE_OTHER_SETTINGS = `${API_URL}/user/settings`
const UPDATE_USER_DEFAULT_COMPANY = `${API_URL}/user/default-company`
const UPDATE_COMPANY_OTHER_SETTINGS = `${API_URL}/company/settings`
const CREATE_LOCALE = `${API_URL}/user-meta`
export const GET_FILE_URL = `${API_URL}/file`
const GET_COMPANY_DATA = `${API_URL}/company`
const UPDATE_COMPANY_DATA = `${API_URL}/company`
const GET_REFERRAL_DATA = `${API_URL}/referral/code`
const UPDATE_PAYPAL_EMAIL = `${API_URL}/referral/paypal`
const TOTAL_REFERRAL_EARNING = `${API_URL}/referral/earnings`
const SENDER_PROFILE_INFO = `${API_URL}/mailer`
const PROFILE_COMPLETION = `${API_URL}/profile/status`
const BCC_TRACKING_DATA = `${API_URL}/bcc`
const USERS_DATA = `${API_URL}/company`
const TRANSFER_OWNERSHIP = `${API_URL}/company/users/transfer-ownership`
const AUTH_INVITE = `${API_URL}/auth/invite`
const BILLING_DATA = `${API_URL}/billing`
const BILLING_PORTAL = `${API_URL}/billing/access`
const BILLING_INVOICES = `${API_URL}/billing/invoices`
const PENDING_USERS = `${API_URL}/team/pending-invite`
const NYLAS_OAUTH_URL = `${API_URL}/nylas/auth-url`
const NYLAS_CONNECT = `${API_URL}/nylas/connect`
const NYLAS_ACTIVE = `${API_URL}/mailer`
const GET_USER_INFO = `${API_URL}/userInfo`
const QUOTA = `${API_URL}/quota`
const AI_MEMORY = `${API_URL}/ai-memories`
const GET_QUOTA = `${API_URL}/quotas`
const PROMOTER = `${API_URL}/promoter`
const DUE_PAYMENTS = `${API_URL}/billing/collect-due-payments`
const CREATE_ROLE = `${API_URL}/roles`
const RECEIVED_INVITES = `${API_URL}/team/received-invites`

export const profileData = (companyId: any) => {
  return axios.get(`${GET_PROFILE_DATA}?companyId=${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const createEmailPreferences = (preference: string, companyId: number) => {
  return axios.post(
    CREATE_EMAIL_PREFERENCES,
    {
      preference,
      companyId,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getEmailPreferences = (companyId: number) => {
  return axios.get(`${API_URL}/email-preferences/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateOtherSettings = (showHelpBanners: boolean, companyId: number) => {
  return axios.post(
    UPDATE_OTHER_SETTINGS,
    {
      showHelpBanners,
    },
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export function updateUserDefaultCompany(companyId: number, defaultCompanyId: number) {
  return axios.post(
    UPDATE_USER_DEFAULT_COMPANY,
    {
      defaultCompanyId: defaultCompanyId,
    },
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status: any) {
        return true
      },
    }
  )
}

export const updateCompanyOtherSettings = (showDemoDashboard: boolean, companyId: number) => {
  return axios.post(
    UPDATE_COMPANY_OTHER_SETTINGS,
    {showDemoDashboard},
    {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    }
  )
}

export const createLocale = (key: string, value: string, companyId: number) => {
  return axios.post(
    CREATE_LOCALE,
    {
      key,
      value,
      companyId,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getLocale = () => {
  return axios.get(`${API_URL}/user-meta`, {
    validateStatus(status) {
      return true
    },
  })
}

export const companyData = (companyId: number) => {
  return axios.get(`${GET_COMPANY_DATA}/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateProfileInfo = (profileData: ProfileType) => {
  return axios.put(UPDATE_PROFILE_DATA, profileData, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateCompanyProfile = (data: any) => {
  data.currencyId = parseInt(data.currencyId)
  return axios.put(UPDATE_COMPANY_DATA, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getReferralData = () => {
  return axios.get(GET_REFERRAL_DATA, {
    validateStatus(status) {
      return true
    },
  })
}

export const putPaypalReferralEmail = (data: {paypalEmail: string | undefined}) => {
  return axios.put(
    UPDATE_PAYPAL_EMAIL,
    {paypalEmail: data.paypalEmail},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getTotalReferralEarning = () => {
  return axios.get(TOTAL_REFERRAL_EARNING, {
    validateStatus(status) {
      return true
    },
  })
}

export const createSenderProfileInfo = (data: any) => {
  return axios.post(SENDER_PROFILE_INFO, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getMailInfo = (companyId: number | undefined) => {
  return axios.get(`${SENDER_PROFILE_INFO}/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const createSendgridMail = (companyId: number | undefined, data: any) => {
  return axios.post(
    SENDER_PROFILE_INFO,
    {companyId, sendgrid: data},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const createCustomSmtpMail = (companyId: number | undefined, data: any) => {
  return axios.post(
    SENDER_PROFILE_INFO,
    {companyId, smtp: data},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const createPostmarkMail = (companyId: number | undefined, data: any) => {
  const payload = {
    companyId,
    postmark: data,
  }
  return axios.post(SENDER_PROFILE_INFO, payload, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateIsActive = (companyId: number | undefined, data: any) => {
  return axios.put(`${SENDER_PROFILE_INFO}/${companyId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const getProfileCompletionAPI = (companyId: number) => {
  return axios.get(`${PROFILE_COMPLETION}/${companyId}`)
}

export const getBccTrackingData = (companyId: number | undefined) => {
  return axios.get(`${BCC_TRACKING_DATA}/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getUserList = (companyId: number | undefined) => {
  return axios.get(`${USERS_DATA}/${companyId}/users`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateTransferOwnership = (
  companyId: number | undefined,
  userId: number | undefined
) => {
  return axios.post(
    TRANSFER_OWNERSHIP,
    {companyId, userId},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const addUser = (data: any) => {
  return axios.post(AUTH_INVITE, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteUser = (companyId: number | undefined, userId: number) => {
  return axios.delete(`${USERS_DATA}/${companyId}/users/${userId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getUser = (companyId: number | undefined, userId: number) => {
  return axios.get(`${USERS_DATA}/${companyId}/users/${userId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const editUser = (userId: number | undefined, data: any) => {
  return axios.put(`${USERS_DATA}/users/${userId}`, data, {
    validateStatus(status) {
      return true
    },
  })
}

export const sendTestMail = (companyId: number | undefined, mailType: string) => {
  return axios.post(
    `${SENDER_PROFILE_INFO}/test/${companyId}`,
    {mailType},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getBillingData = (companyId: number | undefined) => {
  return axios.get(`${BILLING_DATA}/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllInvoices = (companyId: number | undefined) => {
  return axios.get(BILLING_INVOICES, {
    headers: {
      'x-company-id': companyId || 0,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getInvoiceDownloadUrl = (invoiceId: string) => {
  return axios.get(`${BILLING_INVOICES}/${invoiceId}/download`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getBillingAccess = (companyId: number | undefined) => {
  return axios.get(`${BILLING_PORTAL}/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateBillingAccess = (companyId: number | undefined, chargebeePlanId: string) => {
  return axios.put(
    `${BILLING_DATA}/${companyId}`,
    {chargebeePlanId},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}
export const getPendingUsers = (companyId: number) => {
  return axios.get(`${PENDING_USERS}/${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const deletePendingInvite = (inviteId: number) => {
  return axios.delete(`${PENDING_USERS}/delete/${inviteId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getNylasOauthUrl = (provider: string, companyId?: number) => {
  return axios.get(`${NYLAS_OAUTH_URL}?provider=${provider}&companyId=${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const connectNylas = (
  code: string | null,
  companyId: number | undefined,
  provider: string
) => {
  return axios.post(
    NYLAS_CONNECT,
    {code, companyId, provider},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const activeNylas = (isNylasActive: any, companyId: any) => {
  return axios.put(
    `${NYLAS_ACTIVE}/${companyId}`,
    {isNylasActive: isNylasActive},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}
export const disconnectNylas = (isNylasActive: any, companyId: any) => {
  return axios.put(
    `${NYLAS_ACTIVE}/disconnect/${companyId}`,
    {isNylasActive: isNylasActive},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getUserInfo = (companyId: number) => {
  return axios.get(`${GET_USER_INFO}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const accessPortalForQuotaUpgrade = (companyId: number, payload: any) => {
  return axios.post(`${QUOTA}/access-portal`, payload, {
    validateStatus(status) {
      return true
    },
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const processUpgradeQuota = (companyId: number, hostedPageId: string) => {
  return axios.post(
    `${QUOTA}/process`,
    {hostedPageId},
    {
      validateStatus(status) {
        return true
      },
      headers: {
        'x-company-id': companyId,
      },
    }
  )
}
export const accessPortalForUpdatePlan = (companyId: number, payload: any) => {
  return axios.post(`${BILLING_PORTAL}/hosted-page`, payload, {
    validateStatus(status) {
      return true
    },
    headers: {
      'x-company-id': companyId,
    },
  })
}
export const createAiMemory = (payload: any) => {
  return axios.post(`${AI_MEMORY}`, payload, {
    validateStatus(status) {
      return true
    },
  })
}
export const updateAiMemory = (payload: any, memoryId: string) => {
  return axios.post(`${AI_MEMORY}/${memoryId}`, payload, {
    validateStatus(status) {
      return true
    },
  })
}
export const getAiMemories = (
  aiMemoryFor: string,
  page: number,
  size: number,
  search: string,
  date?: string,
  entityId?: number
) => {
  const object = {
    aiMemoryFor,
    page,
    size,
    search,
    date,
    entityId,
  }
  return axios.get(`${AI_MEMORY}?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
  })
}
export const getAiMemory = (memoryId: string) => {
  return axios.get(`${AI_MEMORY}/${memoryId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const deleteAiMemory = (memoryId: string) => {
  return axios.delete(`${AI_MEMORY}/${memoryId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getAllQuota = (companyId: number, payload: any) => {
  return axios.post(`${GET_QUOTA}`, payload, {
    validateStatus(status) {
      return true
    },
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const getQuotaGraph = (
  companyId: number,
  selectedDataActivity: string,
  userIdsString: string
) => {
  const object = {
    filter: selectedDataActivity,
    userIds: userIdsString,
  }
  return axios.get(`${QUOTA}/overview?${serialize(object)}`, {
    validateStatus(status) {
      return true
    },
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const promoterLogin = () => {
  return axios.get(`${PROMOTER}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const payDuePayments = (companyId: number, payload: any) => {
  return axios.post(`${DUE_PAYMENTS}`, payload, {
    validateStatus(status) {
      return true
    },
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const createRole = (companyId: number, payload: any) => {
  return axios.post(`${CREATE_ROLE}`, payload, {
    validateStatus(status) {
      return true
    },
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const getAllRoles = (companyId: number, showDetails?: boolean) => {
  const queryParam = showDetails ? '?detailed=true' : ''
  return axios.get(`${CREATE_ROLE}${queryParam}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}
export const deleteRole = (companyId: number, roleId: string) => {
  return axios.delete(`${CREATE_ROLE}/${roleId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const getRole = (companyId: number, roleId: string) => {
  return axios.get(`${CREATE_ROLE}/${roleId}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

export const updateRole = (companyId: number, roleId: string, payload: any) => {
  return axios.post(`${CREATE_ROLE}/${roleId}`, payload, {
    validateStatus(status) {
      return true
    },
    headers: {
      'x-company-id': companyId,
    },
  })
}

export const getReceivedInvites = () => {
  return axios.get(`${RECEIVED_INVITES}`, {
    validateStatus(status) {
      return true
    },
  })
}
